import { render, staticRenderFns } from "./ReadClassic.vue?vue&type=template&id=5e6364e0&"
import script from "./ReadClassic.vue?vue&type=script&lang=ts&"
export * from "./ReadClassic.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports